import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionLinkRequest,
  CvSectionLink,
  CvSectionLinkResponse,
} from '@/../gen';

export const namespace = 'cvSectionLinkNew';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_LINK');
export const SetCvSectionLink = actionCreator<CvSectionLinkResponse>(
  'SET_CV_SECTION_LINK'
);
export const CreateCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
  };
  body: CreateCvSectionLinkRequest;
}>('CREATE_CV_SECTION_LINK');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionLink: CvSectionLink;
}

const initialState = (): State => {
  return { cvSectionLink: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionLink, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionLink(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLink(data.data));
    }),
    action(CreateCvSectionLink, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionLink(
        action.payload.params.cv_id,
        action.payload.body
      );
      context.commit(SetCvSectionLink(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionLink, (state, action) => {
      state.cvSectionLink = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionLink: state => state.cvSectionLink,
  },
};
